import { STEP_UP_ERROR } from '../constants/response-headers';

/**
 * Parses string into a JavaScript object.
 *
 * @param {string} header - The header string to parse. This should be in the format 'key1="value1", key2="value2"...'.
 * @returns {Object|undefined} An object representing the key-value pairs from the header, or undefined if the header could not be parsed.
 */
export const parseCommaDelimitedValues = s => {
  let parsed;
  try {
    parsed = JSON.parse(`{${s.replace(/(\w+)="([^"]+)"/g, '"$1":"$2"')}}`);
  } catch (e) {
    parsed = undefined;
  }
  return parsed;
};

/**
 * Parses the step-up authentication from a error message.
 *
 * @param {string} message - The error message from the response
 * @returns {{error: string, mfa: boolean, assuranceLevel: number}|undefined} An object containing the parsed values if the error is 'insufficient_user_authentication', otherwise undefined.
 */
export const parseStepUpMessage = ({
  message
}) => {
  if (!message) {
    return undefined;
  }
  const parsed = parseCommaDelimitedValues(message.replace(/Bearer /, ''));
  if (parsed?.error !== STEP_UP_ERROR) {
    return undefined;
  }
  return {
    error: parsed.error,
    mfa: parsed.mfa === 'true',
    assuranceLevel: parseInt(parsed.assuranceLevel, 10)
  };
};